import resourceService from './resource_service';

const modelName = 'allocation-unit';

const attributes = {
  name: '',
  mac: '',
  subscribed: '',
  lastSyncTime: '',
  lastDispenseTime: '',
};

const readOnlyAttributes = ['lastSyncTime', 'lastDispenseTime'];

const relationships = {
  site: {
    jsonApi: 'hasOne',
    update: true,
  },
  manifolds: {
    jsonApi: 'hasMany',
  },
};

export default resourceService(modelName, attributes, relationships, readOnlyAttributes);
